"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = void 0;
const zod_1 = require("zod");
exports.UiConfigSchema = zod_1.z.object({
    description: zod_1.z.string(),
    creditFacilitySlug: zod_1.z.string(),
    useReceivableWaivers: zod_1.z.boolean().optional().describe(`
   * this optional field will determine if calc-agent should use
   * receivable borrowing base test waivers when generating the receivable response tape.
   * If this field is not set, receivable waivers will not be used
    `),
});
exports.nodeType = 'operation_calcAgent';
//# sourceMappingURL=types.js.map